import {getApiList} from "@/api/backend";
import {factoryGetters, factoryMutations, factoryState} from "@/store/Modules/_factoryList";

const state = JSON.parse(JSON.stringify(factoryState));

const mutations = {
  ...factoryMutations,
};

const getters = {
  ...factoryGetters,
};

const actions = {
  async fetchList(context, {token, page}) {
    try {
      const filters = context.getters.getFilters;
      const list = (await getApiList('/customers', token, {...filters, page}));

      const result = list.items.map(
        ({ id, active, firstName, lastName, email, phone }) => ({
          id,
          avatar: `${firstName} ${lastName}`,
          firstName,
          lastName,
          email,
          phone,
          active: active ? 'TAK' : 'NIE',
        })
      );

      return context.commit('setItems', {items: result, totalItems: list.totalItems});
    } catch ({response}) {
      return context.commit('setApiError', { isError: true, status: response?.status });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
